import type { ComponentType } from "react";
import { cn } from "@/lib/cn";

export type PhosphorIconComponent = ComponentType<{
  size?: number | string;
  weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  className?: string;
  "aria-hidden"?: boolean | "true" | "false";
}>;

export type IconProps = {
  icon: PhosphorIconComponent;
  size?: "xs" | "sm" | "md" | "lg" | number;
  weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  className?: string;
  decorative?: boolean;
};

const sizeMap = {
  xs: 13,
  sm: 16,
  md: 20,
  lg: 24
};

export function Icon({ icon: IconComponent, size = "md", weight = "regular", className, decorative = true }: IconProps) {
  const resolvedSize = typeof size === "number" ? size : sizeMap[size];
  return <IconComponent aria-hidden={decorative} className={cn("bfrs-inline-block bfrs-shrink-0 bfrs-align-middle", className)} size={resolvedSize} weight={weight} />;
}
